import { postWithToken } from "../authentication/AuthProvider";
import { apiUrl } from "../config";

const life_cycle_assessment = apiUrl + "/life_cycle_assessment";
const routes = {
  label: "Life Cycle Assessment",
  root: life_cycle_assessment,
  new: life_cycle_assessment + "/new",
  update_lca_by_product: life_cycle_assessment + "/update_lca_by_product",
  update_lca_by_project: life_cycle_assessment + "/update_lca_by_project",
  update_lca_by_reused_product: life_cycle_assessment + "/update_lca_by_reused_product",
  get_by_product_id: life_cycle_assessment + "/get_by_product_id",
  get_by_project_id: life_cycle_assessment + "/get_by_project_id",
  get_by_reused_product_id: life_cycle_assessment + "/get_by_reused_product_id",
  reset_for_reused_product: life_cycle_assessment + "/reset_for_reused_product",
};

export const LifeCycleAssessment = {
  new: (lca) => postWithToken(routes.new, lca),
  update_lca_by_product: (lca) => postWithToken(routes.update_lca_by_product, lca),
  update_lca_by_project: (lca) => postWithToken(routes.update_lca_by_project, lca),
  update_lca_by_reused_product: (lca) => postWithToken(routes.update_lca_by_reused_product, lca),
  get_by_product_id: (product_id) => postWithToken(routes.get_by_product_id, { product_id }),
  get_by_project_id: (project_id) => postWithToken(routes.get_by_project_id, { project_id }),
  get_by_reused_product_id: (reused_product_id) => postWithToken(routes.get_by_reused_product_id, { reused_product_id }),
  reset_for_reused_product: (reused_product_id) => postWithToken(routes.reset_for_reused_product, { reused_product_id }),
};
